import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';
import Detail from '../../../components/Detail/Detail';

const cx = classNames.bind(styles);

const Result = ({ randomNumber, result, modulusBy }) => {
  function getContent() {
    return (
      <div className={cx('hidden')}>
        <span className={cx('small')}>{randomNumber}</span>
        {result && (
          <div className={cx('mt-8', 'flex-center')}>
            <span className={cx('mt-8', 'small')}>%</span>
            <span className={cx('modulus-by', 'small')}>{modulusBy}</span>
            <span className="small">=</span>
            <h5 className={cx('result')}>{result}</h5>
          </div>
        )}
      </div>
    );
  }
  return (
    <Detail
      className={cx('result')}
      label="Result"
      content={getContent()}
      copyText={randomNumber}
      copiable={!!randomNumber}
    />
  );
};

Result.propTypes = {
  result: PropTypes.string.isRequired,
  randomNumber: PropTypes.string.isRequired,
  modulusBy: PropTypes.number.isRequired,
};

export default Result;
